var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImagePause = function SvgImagePause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M17.9 0h11.2v32H17.9zM0 0h11.2v32H0z"
  })));
};
export { SvgImagePause as ReactComponent };
export default __webpack_public_path__ + "assets/ImagePause.4593867d29242f884b7ce3e3624f9f88.svg";